import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.scss']
})


export class ServiceListComponent implements OnInit {


  apiUrl = environment.apiUrl;
  merchants: any[] = [];
  allMerchants: any[] = [];
  category: string = '';
  categoryId: string = '';

  displayCategoryName: string = '';
  loading: boolean = true;
  searchCity: string = '';
  urlCity = '';
  // Mock UI Filter Data
  cities: any[] = [];
selectedCities: string[] = [];
showCityDropdown = false;
  ratings = [5, 4, 3];
  selectedCity = '';
  selectedRating = 0;
shortlistedMerchantIds: string[] = [];
ownerProfileId: string = '';


  constructor(

    private apiService: ApiServiceService,

    private route: ActivatedRoute,

    private router: Router

  ) { }





  ngOnInit(): void {
    this.ownerProfileId = localStorage.getItem('profileId') || '';

  if (this.ownerProfileId) {
    this.loadShortlistedMerchants();
  }

    this.getMerchantCities();

    this.route.paramMap.subscribe(params => {



      const slug =
        params.get('category') || '';

      this.category =
        slug.replace(/-/g, ' ');

      // Reset title temporarily until data loads
      this.displayCategoryName = 'Loading...';

      this.route.queryParamMap.subscribe(qParams => {
        this.urlCity = qParams.get('city') || '';
        if (this.category) {
          this.getMerchantsByCategory();
        }
      });

    });



  }







  getMerchantsByCategory() {


    this.apiService
      .getMerchantsByCategory(this.category)

      .subscribe({


        next: (response) => {

          console.log(
            "Merchant List Response",
            response
          );

          this.allMerchants = response.data || [];

let allMerchants = [...this.allMerchants];
          if (this.urlCity) {
            const sc = this.urlCity.toLowerCase();
            allMerchants = allMerchants.filter((m: any) => {
              const loc = m.location || m.city || 'Chennai';
              const dist = m.district || '';
              return loc.toLowerCase().includes(sc) || dist.toLowerCase().includes(sc);
            });
          }

          this.merchants = allMerchants;

          // Fix the display title dynamically
          if (this.merchants && this.merchants.length > 0 && this.merchants[0].category) {
            this.displayCategoryName = this.merchants[0].category.name;
          } else {
            this.displayCategoryName = 'Vendor';
          }
          this.loading = false;

        },

        error: (error) => {

          console.log(
            "Merchant Fetch Error",
            error
          );
          this.loading = false;

        }


      });


  }
  loadShortlistedMerchants(): void {

  if (!this.ownerProfileId) {
    console.warn('Owner profile ID not available');
    return;
  }

  this.apiService
    .getShortlistedMerchants(this.ownerProfileId)
    .subscribe({

      next: (response: any) => {

        console.log(
          'Shortlisted Merchants Response:',
          response
        );

        const shortlisted = response.data || [];

        this.shortlistedMerchantIds = shortlisted
          .map((item: any) => item.merchant?._id)
          .filter((id: any) => !!id);

      },

      error: (error) => {

        console.error(
          'Shortlisted Merchants Fetch Error:',
          error
        );

        this.shortlistedMerchantIds = [];

      }

    });
}
isMerchantShortlisted(merchantId: string): boolean {
  return this.shortlistedMerchantIds.includes(String(merchantId));
}
toggleShortlist(merchant: any, event: Event): void {

  event.stopPropagation();

  if (!this.ownerProfileId) {
    console.warn('Owner profile ID not available');
    return;
  }

  const merchantId = String(merchant._id);

  const alreadyShortlisted =
    this.isMerchantShortlisted(merchantId);

  if (alreadyShortlisted) {

    // REMOVE
    this.apiService
      .removeShortlistedMerchant(
        this.ownerProfileId,
        merchantId
      )
      .subscribe({

         next: (response: any) => {

        console.log(
          'Merchant removed from shortlist:',
          response
        );

        // Remove merchant from local shortlist
        this.shortlistedMerchantIds =
          this.shortlistedMerchantIds.filter(
            id => id !== merchantId
          );

        // Show confirmation on screen
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Removed from shortlist',
          showConfirmButton: false,
          timer: 2000
        });

      },

      });

  } else {

    // ADD
    this.apiService
      .shortlistMerchant(
        this.ownerProfileId,
        merchantId
      )
      .subscribe({

        next: (response: any) => {

  console.log('Merchant shortlisted:', response);

  this.shortlistedMerchantIds.push(merchantId);

  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'success',
    title: 'Added to shortlist',
    showConfirmButton: false,
    timer: 2000
  });

},

        error: (error) => {

          console.error(
            'Error shortlisting merchant:',
            error
          );

        }

      });

  }

}

getMerchantCities(): void {
  this.apiService.getMerchantCities().subscribe({
    next: (response: any) => {
      console.log('Merchant Cities Response:', response);

      this.cities = response.data || [];
    },
    error: (error) => {
      console.error('Merchant Cities Fetch Error:', error);
      this.cities = [];
    }
  });
}
onCityChange(cityName: string, event: any): void {

  if (event.target.checked) {

    if (!this.selectedCities.includes(cityName)) {
      this.selectedCities.push(cityName);
    }

  } else {

    this.selectedCities = this.selectedCities.filter(
      city => city !== cityName
    );

  }

  this.applyFilters();
}


applyFilters(): void {

  // Always filter from the original API result
  let filteredMerchants = [...this.allMerchants];

  if (this.selectedCities.length > 0) {

    filteredMerchants = filteredMerchants.filter((merchant: any) => {

      const merchantCity = (
        merchant.city ||
        merchant.location ||
        ''
      ).toLowerCase().trim();

      return this.selectedCities.some(
        city => city.toLowerCase().trim() === merchantCity
      );

    });

  }

  this.merchants = filteredMerchants;
}
clearFilters(): void {

  this.selectedCities = [];

  // Restore all merchants
  this.merchants = [...this.allMerchants];

}
getFilteredCities(): any[] {

  const search = this.searchCity.toLowerCase().trim();

  if (!search) {
    return this.cities;
  }

  return this.cities.filter((city: any) =>
    city.city_nme.toLowerCase().includes(search)
  );

}


onCitySelect(event: any): void {

  const cityName = event.target.value;

  this.selectedCity = cityName;

  if (cityName) {
    this.selectedCities = [cityName];
  } else {
    this.selectedCities = [];
  }

  this.applyFilters();
}

  openMerchant(merchantId: string) {



    this.router.navigate([


      '/wedding-services/merchant',

      merchantId



    ]);



  }




}